/* eslint-disable no-undef */
import React from "react"
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Point, MarkerWithLabel } from "react-google-maps"

const MyMapComponent = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyB3oRQIuSJQUF5WXC40mfp3y1VxgyU-59M&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }), withScriptjs, withGoogleMap) ((props) =>
  <GoogleMap
    defaultZoom={12}
    defaultCenter={{ lat: 56.3556, lng: -2.8239 }}
  >
    {<Marker 
      label={"Leuchar's train station"}
      position={{ lat: 56.375046, lng: -2.893576 }} 
      //icon={"https://firebasestorage.googleapis.com/v0/b/rebeccaandmatthew-57703.appspot.com/o/Icons%2FtrainIcon.png?alt=media&token=195c1260-ee35-4db2-bc62-55d8c70f50b2"}
    />}
    {<Marker 
      label={"St Salvators Chapel"}
      position={{ lat: 56.341377, lng: -2.794368 }}
      //icon={"https://firebasestorage.googleapis.com/v0/b/rebeccaandmatthew-57703.appspot.com/o/Icons%2FchurchIcon.png?alt=media&token=3d5ca9ea-510b-4016-860d-84caba52a200"}
    />}
    {<Marker 
      label={"Kinkell Byre"}
      position={{ lat: 56.322714, lng: -2.744993 }}
      //icon={"https://firebasestorage.googleapis.com/v0/b/rebeccaandmatthew-57703.appspot.com/o/Icons%2FkinkellIcon.png?alt=media&token=be0bd5a3-6cbb-41e5-b34d-1d66c7cb77d7"}
    />}
  </GoogleMap>
)

class MyFancyComponent extends React.PureComponent {
  state = {
    isMarkerShown: true,
  }

  componentDidMount() {
    this.delayedShowMarker()
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true })
    }, 3000)
  }

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false })
    this.delayedShowMarker()
  }

  render() {
    return (
      <MyMapComponent
        isMarkerShown={this.state.isMarkerShown}
        onMarkerClick={this.handleMarkerClick}
      />
    )
  }
}

export default MyFancyComponent;


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/MapComponent.jsx